<template>
  <div class="q-pt-md">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :filter="filter"
      title="Usuários já com regra"
      :rows="rows"
      :columns="columns"
      :loading="disable"
      v-model:pagination="pagination"
      hide-pagination
      dense
      class="tabela-tamanho-fixo"
      @request="handleRequest"
    >
      <template v-slot:top-right>
        <q-input
          outlined
          rounded
          dense
          debounce="300"
          v-model="filter"
          placeholder="Buscar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template #body-cell-minimo="props">
        <q-td>
          <div style="width: 100px" v-if="editarr == props.row.id">
            <q-input dense outlined v-model="props.row.minimum_days" />
          </div>
          <span v-else>{{ props.row.minimum_days }}</span>
        </q-td>
      </template>
      <template #body-cell-maximo="props">
        <q-td>
          <div style="width: 100px" v-if="editarr == props.row.id">
            <q-input dense outlined v-model="props.row.maximum_days" />
          </div>
          <span v-else>{{ props.row.maximum_days }}</span>
        </q-td>
      </template>
      <template #body-cell-amount="props">
        <q-td>
          <div style="width: 100px" v-if="editarr == props.row.id">
            <q-input dense outlined v-model="props.row.max_amount" />
          </div>
          <span v-else>{{ props.row.max_amount }}</span>
        </q-td>
      </template>

      <template #body-cell-critico="props">
        <q-td style="width: 180px">
          <div v-if="editarr == props.row.id">
            <q-select
              :options="critico"
              dense
              outlined
              label="Critico"
              option-label="label"
              option-value="value"
              map-options
              v-model="props.row.critico"
            />
          </div>
          <div v-else>
            <span v-if="props.row.critico == 0">NÃO</span>
            <span v-else>SIM</span>
          </div>
        </q-td>
      </template>
      <template #body-cell-deletar="props">
        <q-td>
          <q-btn
            @click="deletar(props.row.id)"
            color="negative"
            round
            icon="delete"
          />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Descrição",
    field: "name",
    align: "left",
  },
  {
    name: "minimo",
    label: "Prazo Min.",
    field: (row) => row.minimum_days,
    align: "left",
  },
  {
    name: "maximo",
    label: "Prazo Máx.",
    field: (row) => row.maximum_days,
    align: "left",
  },
  {
    name: "amount",
    label: "Quantidade",
    field: (row) => row.max_amount,
    align: "left",
  },
  {
    name: "critico",
    label: "Crítico?",
    field: "critico",
    align: "left",
  },
  {
    name: "deletar",
    label: "Deletar",
    field: "deletar",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
export default {
  props: ["atualizar", "id"],
  setup(props) {
    const $q = useQuasar();
    const store = useStore();
    const rows = ref([]);
    const disable = ref(true);
    let filter = ref("");
    const route = useRoute();
    const dados = JSON.parse(route.params.id);
    const typeEdit = ref(false);
    const regras = ref("");
    const criticoValue = ref();
    const editarr = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getPessoasGrupos = async (page = 1, rowsPerPage = 15) => {
      let response = await store.dispatch("grupoProdutos/pessoaRegras", {
        unidade: store.state.org.unidadeData.id,
        per_page: rowsPerPage,
        page: page,
        search: filter.value,
        id: dados.id,
      });

      rows.value = response.data.data[0].users;

      disable.value = false;
    };

    onMounted(getPessoasGrupos);

    const handleRequest = async () => {
      getPessoasGrupos(pagination.value.page, pagination.value.rowsPerPage);
    };

    const editar = async (value) => {
      try {
        await store.dispatch("grupoProdutos/editarFuncaoRegras", {
          unidade: store.state.org.unidadeData.id,
          id: dados.id,
          maximum_days: value.maximum_days,
          minimum_days: value.minimum_days,
          control_types: regras.value?.value,
          amount: value.max_amount,
          cost_center_id: value.id,
          critico: value.critico.label ? value?.critico?.value : value?.critico,
        });

        $q.notify({
          message: "editado com sucesso sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        criticoValue.value = "";
        getPessoasGrupos();
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o editar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const deletar = async (id) => {
      try {
        await store.dispatch("grupoProdutos/deletarPessoaRegras", {
          pessoas_id: id,
          id: dados.id,
        });

        $q.notify({
          message: "removido com sucesso sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getPessoasGrupos();
      } catch (error) {
        $q.notify({
          message: "Erro a o remover",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getPessoasGrupos();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        setTimeout(() => {
          getPessoasGrupos();
        }, 500);
      }
    );

    return {
      columns,
      rows,
      getPessoasGrupos,
      pagination,
      handleRequest,
      disable,
      filter,
      editar,
      editarr,
      typeEdit,
      deletar,
      regras,
      criticoValue,
      critico: [
        {
          label: "SIM",
          value: 1,
        },
        {
          label: "NÃO",
          value: 0,
        },
      ],
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
